<template>
  <v-layout ref="app-layout" class="bg-ternary">
    <TheHeader />

    <div id="smooth-wrapper">
      <div id="smooth-content">
        <v-container maxWidth="1440px" class="py-16">
          <v-main class="my-16 py-0">
            <slot />
          </v-main>
        </v-container>
        <TheFooter />
      </div>
    </div>
  </v-layout>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import companyInfo from '~/data/companyInfo'
const title = companyInfo?.name || 'Truster Cloud'
useHead({
	titleTemplate: (titleChunk) => {
		return titleChunk ? `${titleChunk} - ${title}` : title
	},
})

let smoother: any

onMounted(() => {
	const { $ScrollSmoother } = useNuxtApp()
	smoother = $ScrollSmoother.create({
		wrapper: '#smooth-wrapper',
		content: '#smooth-content',
		smooth: 2.5,
		effects: true
	})
})

onUnmounted(() => {
	if (smoother) {
		smoother.kill()
	}
})
</script>

<style lang="scss" scoped></style>
